import { del, get, post, put } from "../../data/api";

export async function getAdminQrScans(maxItems = 300) {
    return await get(`userprofile/qr-scans?maxItems=${maxItems}`);
}

export async function updateAdminQrCode(qrCodeId, data) {
    return await put(data, `userprofile/qr-codes/${qrCodeId}`);
}

export async function createAdminQrCode(data) {
    return await post(data, "userprofile/qr-codes");
}

export async function deleteAdminQrCode(qrCodeId) {
    return await del(`userprofile/qr-codes/${qrCodeId}`);
}

export async function deleteAdminQrScan(scanId) {
    return await del(`userprofile/qr-scans/${scanId}`);
}
